import { render } from "./EthereumIcon.vue?vue&type=template&id=ab699d9e"
const script = {}
script.render = render

export default script